"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tours = exports.tour_reservation_history = exports.tour_reservation = exports.tour_options = exports.tour_option_date = exports.tour_option_dates = exports.tour_option = exports.tour_legs = exports.tour_leg = exports.tour_enquiry = exports.tour = exports.amenities = exports.room_rate_availability = exports.room_type_availability = exports.room_rate_surcharge_date = exports.room_rate_surcharge_dates = exports.room_rate_included_guest = exports.room_rate_included_guests = exports.included_guest = exports.included_guests = exports.extra_guest_surcharge = exports.extra_guest_surcharges = exports.room_rate_capacity = exports.room_rate_capacities = exports.room_type_capacity = exports.room_type_capacities = exports.room_rate = exports.room_rates = exports.rate_plan = exports.rate_plans = exports.room_type = exports.room_types = exports.property = exports.properties = exports.hotel_reservation_history = exports.hotel_reservation = exports.hotel_enquiry = void 0;
exports.hotel_enquiry = "/api/properties/{property_id}/room-types/{id}/enquiry{?months,offset,nights,currency,timezone_offset,max_date}";
exports.hotel_reservation = "/api/properties/{property_id}/room-types/{room_type_id}/reservations/{id}";
exports.hotel_reservation_history = "/api/hotels/reservations/{item_id}/history{?limit,offset,page}";
// Properties
exports.properties = "/api/properties{?id_salesforce_external,limit,page}";
exports.property = "/api/properties/{id}";
// Room Types
exports.room_types = "/api/properties/{property_id}/room-types";
exports.room_type = exports.room_types + "/{id}";
// Rate Plans
exports.rate_plans = "/api/rate-plans{?id_salesforce_external}";
exports.rate_plan = "/api/rate-plans{id}";
// Room Rates
exports.room_rates = exports.room_types + "/{room_type_id}/room-rates";
exports.room_rate = exports.room_rates + "/{id}";
// Legacy Capacities
exports.room_type_capacities = exports.room_types + "/{room_type_id}/capacities";
exports.room_type_capacity = exports.room_type_capacities + "/{id}";
// Capacities
exports.room_rate_capacities = exports.room_rates + "/{room_rate_id}/capacities";
exports.room_rate_capacity = exports.room_rate_capacities + "/{id}";
// Extra guest surcharges
exports.extra_guest_surcharges = exports.room_rates + "/{room_rate_id}/extra-guest-surcharges";
exports.extra_guest_surcharge = exports.extra_guest_surcharges + "/{id}";
// Legacy Included Guests
exports.included_guests = exports.room_type + "/included-guests";
exports.included_guest = exports.included_guests + "/{id}";
// Included Guests
exports.room_rate_included_guests = exports.room_rates + "/{room_rate_id}/included-guests";
exports.room_rate_included_guest = exports.room_rate_included_guests + "/{id}";
// Surcharges
exports.room_rate_surcharge_dates = exports.room_rates + "/{room_rate_id}/surcharge-dates";
exports.room_rate_surcharge_date = exports.room_rate_surcharge_dates + "/{id}";
exports.room_type_availability = "/api/properties/{property_id}/room-types/{id}/availability";
exports.room_rate_availability = "/api/properties/{property_id}/room-types/{room_type_id}/room-rates/{room_rate_id}/availability";
exports.amenities = "/api/amenities";
exports.tour = "/api/tours/{id}";
exports.tour_enquiry = "/api/tours/{tour_id}/tour-options/{id}/enquiry{?days,timezone_offset,no_of_adults}";
exports.tour_leg = "/api/tours/{tour_id}/tour-legs/{id}";
exports.tour_legs = "/api/tours/{tour_id}/tour-legs";
exports.tour_option = "/api/tours/{tour_id}/tour-options/{id}";
exports.tour_option_dates = "/api/tours/{tour_id}/tour-options/{tour_option_id}/dates";
exports.tour_option_date = "/api/tours/{tour_id}/tour-options/{tour_option_id}/dates/{id}";
exports.tour_options = "/api/tours/{tour_id}/tour-options";
exports.tour_reservation = "/api/tours/{tour_id}/tour-options/{tour_option_id}/reservations/{id}";
exports.tour_reservation_history = "/api/tours/reservations/{item_id}/history{?limit,offset,page}";
exports.tours = "/api/tours{?id_salesforce_external,limit,page}";
